import { render, staticRenderFns } from "./AiBookVersionMessage.vue?vue&type=template&id=bb4a79ee&scoped=true"
import script from "./AiBookVersionMessage.vue?vue&type=script&lang=js"
export * from "./AiBookVersionMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4a79ee",
  null
  
)

export default component.exports